import React from 'react';
import Cell from '../ui/Cell';
import LoadingCell from '../ui/LoadingCell';

// Lazy Loading Indicator Component
const LazyLoadingIndicator = () => (
  <div className="flex justify-center items-center w-full py-8">
    <div className="flex items-center gap-3">
      <div className="flex gap-1">
        <div className="w-2 h-2 bg-[#726E6C] rounded-full animate-pulse" style={{ animationDelay: '0ms', animationDuration: '1.5s' }}></div>
        <div className="w-2 h-2 bg-[#726E6C] rounded-full animate-pulse" style={{ animationDelay: '300ms', animationDuration: '1.5s' }}></div>
        <div className="w-2 h-2 bg-[#726E6C] rounded-full animate-pulse" style={{ animationDelay: '600ms', animationDuration: '1.5s' }}></div>
      </div>
      <p className="text-sm font-medium text-[#726E6C]">Loading more songs...</p>
    </div>
  </div>
);

const WorkspaceList = ({ onCellAction, isCreating, isCompact = false, newSongs = [], activeFilters = [], likedSongs = new Set(), dislikedSongs = new Set(), commentedSongs = new Set(), publishedSongs = new Set(), selectedSongs = new Set(), deletedSongs = new Set(), playedSongs = new Set(), searchValue = '', multiSelectMode = false, onPlaySong, onPauseSong, onMarkAsPlayed, currentlyPlayingSong = null, isLibrary = false, onRowClick, songs: propSongs, selectedStyles = [], isLoadingMore = false, hasMoreSongs = true, onCollapseNavigation, additionalSongs = [], loadedPages = 1 }) => {
  

  // Sample song data (fallback if no songs provided)
  const defaultSongs = [
    {
      id: 1,
      title: "Blue Light Goodbye",
      genres: "Techno, House, Minimal Techno",
      duration: "2:56",
      image: "https://images.unsplash.com/photo-1611348586804-61bf6c080437?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 1200
    },
    {
      id: 2,
      title: "Lost in Translation (remix)",
      genres: "Nordic Folk, Pagan Metal, Dark Ambient",
      duration: "3:42",
      image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=67&h=67&fit=crop&crop=center",
      status: "inactive",
      isNew: false,
      likeCount: 890
    },
    {
      id: 3,
      title: "Electric Pulse",
      genres: "EDM, Progressive House, Trance",
      duration: "4:18",
      image: "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 2100
    },
    {
      id: 4,
      title: "After Hours",
      genres: "Jazz, Smooth Jazz, Neo-Soul",
      duration: "5:23",
      image: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=67&h=67&fit=crop&crop=center",
      status: "pending",
      isNew: false,
      likeCount: 567
    },
    {
      id: 5,
      title: "Untitled",
      genres: "Ambient, Chillout, New Age",
      duration: "6:12",
      image: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 3400
    },
    {
      id: 6,
      title: "Neon Nights",
      genres: "Synthwave, Retrowave, Cyberpunk",
      duration: "3:57",
      image: "https://images.unsplash.com/photo-1619983081563-430f63602796?w=67&h=67&fit=crop&crop=center",
      status: "inactive",
      isNew: false,
      likeCount: 1890
    },
    {
      id: 7,
      title: "Campfire Stories",
      genres: "Folk, Acoustic, Nature Sounds",
      duration: "4:31",
      image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 745
    },
    {
      id: 8,
      title: "Binary Dreams (remix)",
      genres: "Drum & Bass, Neurofunk, Electronic",
      duration: "3:14",
      image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=67&h=67&fit=crop&crop=center",
      status: "pending",
      isNew: false,
      likeCount: 1567
    },
    {
      id: 9,
      title: "Interstellar",
      genres: "Space Rock, Psychedelic, Progressive",
      duration: "7:45",
      image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 4200
    },
    {
      id: 10,
      title: "City Lights",
      genres: "Hip Hop, R&B, Soul",
      duration: "3:28",
      image: "https://images.unsplash.com/photo-1574267432553-4b4628081c31?w=67&h=67&fit=crop&crop=center",
      status: "inactive",
      isNew: false,
      likeCount: 923
    },
    {
      id: 11,
      title: "Untitled",
      genres: "Country, Bluegrass, Folk Rock",
      duration: "4:02",
      image: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 678
    },
    {
      id: 12,
      title: "Frequency Shift (remix)",
      genres: "Glitch Hop, Future Bass, Experimental",
      duration: "5:17",
      image: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=67&h=67&fit=crop&crop=center",
      status: "pending",
      isNew: false,
      likeCount: 1345
    },
    {
      id: 13,
      title: "Solar Flare",
      genres: "Rock, Alternative Rock, Indie",
      duration: "3:36",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 2890
    },
    {
      id: 14,
      title: "Deep Waters",
      genres: "Meditation, Ambient, Healing",
      duration: "8:21",
      image: "https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=67&h=67&fit=crop&crop=center",
      status: "inactive",
      isNew: false,
      likeCount: 512
    },
    {
      id: 15,
      title: "Nostalgic",
      genres: "Lo-Fi, Chillhop, Downtempo",
      duration: "4:44",
      image: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=67&h=67&fit=crop&crop=center",
      status: "active",
      isNew: false,
      likeCount: 1789
    }
  ];

  // Use provided songs or fallback to default songs
  const songs = propSongs || defaultSongs;

  // Combine new songs with existing songs
  const allSongs = [...newSongs, ...songs];

  const handleCellAction = (action, songId) => {
    console.log(`${action} action for song ${songId}`);
    // Find the song data to pass along
    const songData = allSongs.find(song => song.id === songId);
    
    if (action === 'play') {
      // Find the song and trigger playbar
      const songToPlay = allSongs.find(song => song.id === songId);
      if (songToPlay && onPlaySong) {
        onPlaySong(songToPlay);
      }
    }
    
    // Always call the parent handler with songData to preserve remix functionality
    onCellAction?.(action, songId, songData);
  };

  // Apply filtering logic
  const filteredSongs = allSongs.filter(song => {
    // Exclude deleted songs
    if (deletedSongs.has(song.id)) {
      return false;
    }

    // Search filter
    if (searchValue) {
      const searchLower = searchValue.toLowerCase();
      const matchesSearch = song.title.toLowerCase().includes(searchLower) || 
                          song.genres.toLowerCase().includes(searchLower);
      if (!matchesSearch) return false;
    }

    // Liked filter
    if (activeFilters.includes('liked')) {
      if (!likedSongs.has(song.id)) return false;
    }

    // Hide disliked songs filter
    if (activeFilters.includes('hide-disliked')) {
      if (dislikedSongs.has(song.id)) return false;
    }

    // Styles filter
    if (selectedStyles.length > 0) {
      const songGenres = song.genres.split(',').map(genre => genre.trim());
      const hasMatchingStyle = selectedStyles.some(style => songGenres.includes(style));
      if (!hasMatchingStyle) return false;
    }

    // Add other filters here as needed
    // if (activeFilters.includes('public')) { ... }
    // if (activeFilters.includes('hide-stems')) { ... }

    return true;
  });

  return (
    <div className="flex flex-col justify-start items-start w-full gap-1">
      {/* Show loading cells when creating */}
      {isCreating && (
        <>
          <LoadingCell />
          <LoadingCell />
        </>
      )}
      
      {/* Show filtered songs */}
      {filteredSongs.map((song, index) => (
        <Cell
            key={song.id}
            title={song.title}
            genres={song.genres}
            duration={song.duration}
            image={song.image}
            status={song.status}
            isNew={song.isNew && !playedSongs.has(song.id)}
            isLiked={likedSongs.has(song.id)}
            isDisliked={dislikedSongs.has(song.id)}
            isCommented={commentedSongs.has(song.id)}
            isPublished={publishedSongs.has(song.id)}
            isSelected={selectedSongs.has(song.id)}
            isPlaying={currentlyPlayingSong?.id === song.id}
            multiSelectMode={multiSelectMode}
            isLibrary={isLibrary}
            likeCount={song.likeCount || 0}
            commentCount={song.commentCount || 0}
            onPublish={() => handleCellAction('publish', song.id)}
            onRemix={(action) => handleCellAction(action || 'remix', song.id)}
            onLike={() => handleCellAction('like', song.id)}
            onDislike={() => handleCellAction('dislike', song.id)}
            onComment={() => handleCellAction('comment', song.id)}
            onShare={() => handleCellAction('share', song.id)}
            onMenuClick={() => handleCellAction('menu', song.id)}
            onSelect={() => handleCellAction('select', song.id)}
            onPlay={() => handleCellAction('play', song.id)}
            onPause={() => onPauseSong?.()}
            onMarkAsPlayed={() => onMarkAsPlayed?.(song.id)}
            onRowClick={() => onRowClick?.(song.id)}
            onCollapseNavigation={onCollapseNavigation}
            isCompact={isCompact}
          />
      ))}
      
      {/* Lazy Loading Indicator */}
      {isLoadingMore && <LazyLoadingIndicator />}
      
      {/* End of results message */}
      {!hasMoreSongs && !isLoadingMore && filteredSongs.length > 0 && (
        <div className="flex justify-center items-center w-full py-8">
          <p className="text-sm font-medium text-[#726E6C]">
            You've reached the end of your library
          </p>
        </div>
      )}
    </div>
  );
};

export default WorkspaceList;